export default {
  state: {
    serviceSelection: {
      show: false,
      isLoading: false,
      services: null,
      selectedService: null,
      holiday: null
    }
  },
  mutations: {
    showServiceSelection (state) { state.serviceSelection.show = true },
    hideServiceSelection (state) { state.serviceSelection.show = false },
    setQuotationLoading (state, value) { state.serviceSelection.isLoading = value },
    addService (state, data) { state.serviceSelection.services[data.code] = data.value },
    setServices (state, value) { state.serviceSelection.services = value },
    setSelectedService (state, value) { state.serviceSelection.selectedService = value },
    setHoliday (state, value) { state.serviceSelection.holiday = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/rsvp-edit/service-selection.js